import React from 'react';
import ActionInProgressStore from '../Stores/ActionInProgressStore';
import ConnectToStores from '../Utilities/Decorators/ConnectToStoresDecorator';
import LoadingSpinnerView from './LoadingSpinnerView.jsx';
import applyDecoratorsDoNotUseInNewCode from '../Utilities/Decorators/ApplyDecorators';

/*
 * Show the loading spinner when an action is in progress.
*/
class ShowSpinnerOnActionInProgress extends React.Component {
    static getStores() {
        return [ActionInProgressStore];
    }

    static getPropsFromStores() {
        return {
            actionInProgress: ActionInProgressStore.anyActionInProgress()
        }
    }

    render() {
        if(this.props.actionInProgress === true) {
            return (
                <div className='center'>
                    <LoadingSpinnerView inline={ true }/>
                </div>
            );
        }

        return (
            this.props.children
        );
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(ConnectToStores);

export default withDecorators(ShowSpinnerOnActionInProgress);
